import { render } from "./LayoutMicrosite.vue?vue&type=template&id=5acc6b00"
import script from "./LayoutMicrosite.vue?vue&type=script&lang=js"
export * from "./LayoutMicrosite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__